import React from 'react';
import { formatDate } from 'services/utils';
import { showClasses } from 'services/constants';
import { handleErrors } from 'services/utils';
import { prepareUrl } from 'services/DataSource';

export default function DogShows(props) {

  
  const dog = props.item;
  if (!dog) return null;
  const shows = dog.shows || []; 
  const showsList = shows.filter(show => show.class_in_show).map(show => {
    function sendRegistrationData(e) {
      e.preventDefault();
      dog.send_registration_data({show_id: show.show_id}).catch((request) => {
        handleErrors(request);
      }).then(data => {
        alert("Талон успешно выслан.");
      });
    }
    function resetRegistrationDataSent(e) {
      e.preventDefault();
      dog.reset_registration_data_sent({show_id: show.show_id}).catch((request) => {
        handleErrors(request);
      }).then(data => {
        show.ticket_sent = false;
        props.onChange(dog);
      });
    }
    let token = window.btoa(`${dog.id}-${show.show_id}`);
    return (<li key={show.name}><strong>{show.name}</strong> 
        &nbsp; / <small>{formatDate(show.started_at)}</small>
        &nbsp; / <span>N{show.catalog_number || '__'} / {showClasses[show.class_in_show].name_short_ru} класс ({show.class_in_show})</span>
        <button type="button" disabled={show.ticket_sent} onClick={sendRegistrationData} className="btn btn-link">Выслать талон</button>
        {show.ticket_sent ? <button type="button" onClick={resetRegistrationDataSent} className="btn btn-link">Отметить как не отправленный</button> : ''}
        <a href={prepareUrl(`/vapi/dogs/${token}`, true)} target="_ticket">Печать талона</a>
      </li>)
  });

  return (
    <div>
      <h4>Участие в выставках:</h4>
      <ul className="col-12">
        {showsList}
      </ul>
    </div>
  );

}